import { render, staticRenderFns } from "./zone.vue?vue&type=template&id=54987c24&"
import script from "./zone.vue?vue&type=script&lang=js&"
export * from "./zone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports